import React from "react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";

const SaveButtonWithLabel = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      data-cy="tb-save-new-template-button"
      buttonColor={colors.save}
      label={formatMessage({ id: "common.save" })}
      iconName="save"
      {...props}
    />
  );
};

export default SaveButtonWithLabel;
